import React, { Component } from 'react';
import { Empty } from 'antd';
import intl from "react-intl-universal";


export default class NetError extends Component {
  constructor(props) {
    super(props);
    this.state = {
   
    };
  
  }
  componentDidMount() {
   
  }
  componentWillUnmount() {
    this.setState = () => { return }
  }
  initIntlLang = () => {
   
  };
  render() {
    return (
      <div className={`NetError `}>
          <Empty description={intl.formatMessage({ id: 'Error.offline' })} />
      </div>
    );
  }
}
